import React from 'react'

export default function Header() {
  return (
    <h1> Expense Tracker </h1>
  )
}
